import Vue from 'vue'
import Notice from './noticeList'

Notice.newInstance = props => {
  const _props = props || {}

  const NoticeInstance = new Vue({
    data: _props,
    render (h) {
      return h(Notice, {
        props: _props,
      })
    },
  })

  const component = NoticeInstance.$mount()

  document.body.appendChild(component.$el)
  const msgs = NoticeInstance.$children[0]

  return {
    notice (msgProps) {
      msgs.add(msgProps)
    },
    remove (name) {
      msgs.close(name)
    },
    component: msgs,
    destroy (element) {
      msgs.closeAll()
      setTimeout(function () {
        document.body.removeChild(document.getElementsByClassName(element)[0])
      }, 500)
    },
  }
}

export default Notice
